/**
 * @file コンポーネント：フルバージョン動画ページ
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Contents } from "~/src/components/pages/Video/Video/Contents";

// コンポーネントを返す
export const VideoVideo = () => {
    return <Contents />;
};
